var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"common_box_tit"},[_c('div',[_vm._v("相关问答")]),_c('div',{staticClass:"bom_line"})]),_c('div',{staticClass:"common_no_more",staticStyle:{"height":"248px"}},[_vm._v("暂无内容~")])])
}]

export { render, staticRenderFns }